"use client";

import Button, { IButtonProps } from "@template/components/Button";
import { useEffect, useState } from "react";
import { useTypedDispatch, useTypedSelector } from "@/redux/helpers/hooks.ts";
import { getTldPrices } from "@/redux/slices/store/thunks/getTldPrices.ts";
import * as S from "./styles.ts";
import { H2 } from "@template/components";
import Card from "@template/blocks/domain/DomainPricingCards/Card";
import { getTlds } from "@/redux/slices/store/thunks/getTlds.ts";
import useCurrency from "@/lib/helpers/hooks/useCurrency.ts";

type TldProps = {
  tld: number;
};

type DomainPricingCardsProps = {
  button?: IButtonProps;
  label?: string;
  tlds?: TldProps[];
  us_tlds?: TldProps[];
};

const DomainPricingCards = ({
  tlds = [],
  us_tlds = [],
  button,
  label,
}: DomainPricingCardsProps) => {
  const availableTlds = useTypedSelector((state) => state.store.tlds.tlds);

  const dispatch = useTypedDispatch();
  const currency = useCurrency();

  const [loading, setLoading] = useState(false);
  const visibleTlds = currency === "$" && us_tlds.length > 0;

  useEffect(() => {
    const isValid = currency && (us_tlds?.length || tlds?.length);
    if (!isValid) return;

    const tldsToSearch = visibleTlds ? us_tlds : tlds;

    setLoading(true);
    dispatch(
      getTldPrices({
        ids: tldsToSearch.map(({ tld }) => tld),
      })
    ).finally(() => setLoading(false));
  }, [currency, tlds, us_tlds, dispatch]);

  useEffect(() => {
    if (!availableTlds.loaded) {
      dispatch(getTlds());
    }
  }, [availableTlds.loaded, dispatch]);

  return (
    <S.Wrapper>
      <S.Container>
        {(button?.children || label) && (
          <S.Header>
            {label && <H2>{label}</H2>}
            {button?.children && <Button {...button} />}
          </S.Header>
        )}
        <S.Cards>
          {(visibleTlds ? us_tlds : tlds)
            .filter((item) => item?.tld)
            .map(({ tld }) => (
              <Card
                id={tld}
                key={tld}
              />
            ))}
        </S.Cards>
      </S.Container>
    </S.Wrapper>
  );
};

export default DomainPricingCards;
